import { CeaseRelationships, IncludedResource, UserIncludedResource } from '../types/cease';

export type IncludedIndex = Record<string, Record<string, IncludedResource>>;

export const buildIncludedIndex = (included: IncludedResource[] = []): IncludedIndex => {
  return included.reduce<IncludedIndex>((acc, resource) => {
    if (!resource?.type || !resource?.id) return acc;
    if (!acc[resource.type]) acc[resource.type] = {};
    acc[resource.type][resource.id] = resource;
    return acc;
  }, {});
};

const isUserResource = (resource: IncludedResource | undefined): resource is UserIncludedResource => {
  return !!resource && resource.type === 'user';
};

export const getUserDisplayName = (user: UserIncludedResource | undefined): string => {
  const first = user?.attributes?.first_name?.trim() || '';
  const last = user?.attributes?.last_name?.trim() || '';
  const fullName = `${first} ${last}`.trim();
  if (fullName) return fullName;

  const username = user?.attributes?.username?.trim();
  if (username) return username;

  const email = user?.attributes?.email?.trim();
  if (email) return email;

  return 'Unknown user';
};

type CeaseWithSubmitter = {
  submittedBy?: string;
  submitted_by?: string;
  relationships?: CeaseRelationships;
};

export const getSubmittedByDisplayName = (cease: CeaseWithSubmitter, includedIndex: IncludedIndex): string => {
  const relationshipUserId = cease.relationships?.submitted_by?.data?.id;
  const fallbackUserId = cease.submittedBy ?? cease.submitted_by;
  const userId = relationshipUserId ?? fallbackUserId;

  if (!userId) return 'Unknown user';

  const resource = includedIndex?.user?.[userId];
  if (!isUserResource(resource)) return 'Unknown user';

  return getUserDisplayName(resource);
};
